import * as api from '../../resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchUserClassDictionaryRequest = () => ({
  type: actionTypes.FETCH_USER_CLASS_DICTIONARY_REQUEST,
});

export const fetchUserClassDictionarySuccess = (userClass) => ({
  type: actionTypes.FETCH_USER_CLASS_DICTIONARY_SUCCESS,
  userClass,
});

export const fetchUserClassDictionaryFailure = () => ({
  type: actionTypes.FETCH_USER_CLASS_DICTIONARY_FAILURE,
});

export const fetchUserClassDictionary = () => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;

    dispatch(fetchUserClassDictionaryRequest());

    const result = await api.fetchUserClassDictionary({ locale });
    dispatch(fetchUserClassDictionarySuccess(result));
  } catch (error) {
    console.error('USER_CLASS_DICTIONARY', error);
    dispatch(fetchUserClassDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/user-class-dictionary.actions.js